import React, {useMemo} from 'react';

import {AccountLink} from 'src/components/links';

import {Dropdown} from '@pb/kit-component-dropdown';
import {Group} from '@pb/kit-component-group';
import {Icon, Icons, Sizes} from '@pb/kit-component-icon';


import type {AccountHierarchyTree} from 'src/openapi/admin/models/AccountHierarchyTree';

type Props = {
    hierarchy: AccountHierarchyTree,
};

export const AccountHierarchyIcon: React.FC<Props> = ({hierarchy}) => {
    const parentAccountName = useMemo(
        () => hierarchy.parent?.name + (hierarchy.parent?.isDeleted ? ' (Deleted)' : ''),
        [hierarchy.parent],
    );

    return (
        <Dropdown
            hoverEnabled={true}
            placement="bottom"
            anchor={({anchorRef, getAnchorProps}) => (
                <div ref={anchorRef} {...getAnchorProps()}>
                    <Icon size={Sizes.Size_16} type={Icons.TREE}/>
                </div>
            )}>
            <Group direction="v">
                {hierarchy.parent ? (
                    <Group>
                        <strong style={{width: 100}}>
                            Parent account
                        </strong>
                        <AccountLink
                            place="Account Hierarchy"
                            accountId={hierarchy.parent.accountId}
                            accountName={parentAccountName}
                        />
                    </Group>
                ) : null}
            </Group>
        </Dropdown>
    );
};
